
import { defineComponent, ref, inject, computed, provide } from 'vue'

export default defineComponent({
    name: "acrd-dialog-resumen-f2",
    props: {
        itemForm: {
            type: null,
            required: true,
            default: {}
        }
    },
    setup() {
        const altura = screen.height;
        const loading = ref(false)
        const dialogResF2 = inject("dialogResF2")
        const tabName = ref('first')

        const onOpened = () => {
            //getListInstitutions();
        }

        const onClosed = () => {
            //listInstitutions.value = []
            //listSports.value = []
        }

        return {
            altura,
            loading,
            dialogResF2,
            tabName,
            //events
            onOpened,
            onClosed


        }

    },
})
